module.exports = __webpack_public_path__ + "img/role02.32ac6ac4.png";